const accountSummaryV2Url = "v2/credit/accounts/summary";
export {
  accountSummaryV2Url
};
//# sourceMappingURL=endpoints.js.map
